// Real supplied OnBrand email creatives used in the hero + design-studio showcase.
export const EMAIL_DESIGNS = [
  {
    id: 'grenade',
    brand: 'Grenade',
    alt: 'OnBrand email design for Grenade protein bars',
    src: 'https://customer-assets-jt897jd0.emergentagent.net/job_1e18ea37-1907-4ff7-bdfa-34c250cb28c0/artifacts/7xzbqm6f_GRENADE%20%281%29%20%281%29.webp',
  },
  {
    id: 'huel',
    brand: 'Huel',
    alt: 'OnBrand email design for Huel nutrition',
    src: 'https://customer-assets-jt897jd0.emergentagent.net/job_1e18ea37-1907-4ff7-bdfa-34c250cb28c0/artifacts/93d933vl_Huel%20-%202026-07-14%20-%20%C2%A315%20off%20everything.%20One%20day%20only.%20%E2%9A%A1%EF%B8%8F%201%20%281%29%20%281%29.webp',
  },
  {
    id: 'atpresent',
    brand: 'At Present',
    alt: 'OnBrand email design for At Present jewellery',
    src: 'https://customer-assets-jt897jd0.emergentagent.net/job_1e18ea37-1907-4ff7-bdfa-34c250cb28c0/artifacts/50772tjm_Drive%20click-through%20and%20site%20traffic%20by%20presenting%20two%20distinct%20pearl%20aesthetics%20as%20a%20binary%20identity%20choice%2C%20reducing%20decision%20fatigue%20and%20encouraging%20self-identification.%20%281%29.webp',
  },
  {
    id: 'sculpted',
    brand: 'Sculpted By Aimee',
    alt: 'OnBrand email design for Sculpted By Aimee beauty',
    src: 'https://customer-assets-jt897jd0.emergentagent.net/job_1e18ea37-1907-4ff7-bdfa-34c250cb28c0/artifacts/mi6stzv7_Sculpted%20By%20Aimee%20-%202026-07-24%20-%20A%20summer%20essential%2C%20on%20us%201%20%281%29%20%281%29.webp',
  },
  {
    id: 'elderberry',
    brand: 'All Things Elderberry',
    alt: 'OnBrand email design for All Things Elderberry',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/6y34u5ou_Educate%20parents%20on%20the%20cost%20of%20sick%20days.webp',
  },
  {
    id: 'history',
    brand: 'A Day In History',
    alt: 'OnBrand email design for A Day In History',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/p3yz60s1_Engage%20the%20list%20on%20Father%27s%20Day%20morning%20with%20genuinely%20interesting%20historical%20content%20about%20the%20origin%20of%20the%20occasion%20%E2%80%94%20brand-consistent%2C%20honest%20about%20late%20delivery%2C%20with%20the%20evergreen%20offer%20woven%20in%20naturally%20as%20a%20soft%20close..webp',
  },
  {
    id: 'maxholloway',
    brand: 'Spector Sports Art',
    alt: 'OnBrand email design for Spector Sports Art Max Holloway drop',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/rm7rqgv6_Launch%20Max%20Holloway%20UFC%20card.%20Position%20as%20biggest%20fight%20of%20his%20career%20vs%20one%20of%20the%20biggest%20names%20in%20UFC%20history.%20%281%29.webp',
  },
];

export const NAV_LINKS = [
  { label: 'Results', href: '#results' },
  { label: 'Services', href: '#services' },
  { label: 'Work', href: '#work' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'About', href: '#about' },
  { label: 'FAQs', href: '#faq' },
];

// Official OnBrand booking calendar (Calendly)
export const CALENDLY_URL = 'https://calendly.com/hello-onbrandadmin/30min';

// Real supplied OnBrand client logos (batch 1). 3 more logos will be supplied next.
// simply append them to this array; the marquee sizes/loops automatically.
// `imgClass` normalises each logo's visual weight (different source canvases/ratios).
export const CLIENT_LOGOS = [
  {
    name: 'Heights District',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/ugriqw2t_HEIGHTS%20Logo%20%282%29.webp',
    imgClass: 'max-h-[78px]',
  },
  {
    name: 'Autumn-Blu Beds & Mattresses',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/oijoekct_AB%20Beds%20%26%20Mattresses%20%281%29%20%281%29.png',
    imgClass: 'max-h-[80px]',
  },
  {
    name: 'At Present',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/o3a44efz_images%20%282%29.png',
    imgClass: 'max-h-11 rounded-lg',
  },
  {
    name: 'LEILA',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/qx3ohg0l_LEILA_FullLogo_TerraCotta_400x%20%281%29.webp',
    imgClass: 'max-h-8',
  },
  {
    name: 'Scrandie Beauty',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/j7520n10_Scrandie_beauty.webp',
    imgClass: 'max-h-[82px]',
  },
  {
    name: 'REMI Pro-Active Scalpology',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/lsvmez6g_REMI%20Logo.webp',
    imgClass: 'max-h-12',
  },
  {
    name: 'Spector Sports Art',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/213hsem0_logo.webp',
    imgClass: 'max-h-11 rounded-lg',
  },
  {
    name: 'Nuola Wigs',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/ouvhrwt6_Screen_Shot_2026-02-09_at_15.09.41_1600x.webp',
    imgClass: 'max-h-[84px]',
  },
  {
    name: 'All Things Elderberry',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/6bqwmq8i_ATE.webp',
    imgClass: 'max-h-[74px]',
  },
  {
    name: 'A Day In History',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/61bxvsx0_ADIH.png',
    imgClass: 'max-h-[78px] rounded-lg',
  },
  {
    name: 'ALTAR',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/hrtn4hc4_AutoLinkr%20Wide%20Logo%20-%20Transparent%201.png',
    imgClass: 'max-h-7',
  },
  {
    name: 'Dabble & Dollop',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/2xtmioy0_Dabble%20logo.webp',
    imgClass: 'max-h-[58px] rounded-lg',
  },
  {
    name: 'Buíoch Irish Chocolates',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/edup7egq_HEADER.png',
    imgClass: 'max-h-12',
  },
  {
    name: 'TruA',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/apm6lvjw_TRUA%20Logo.png',
    imgClass: 'max-h-[80px]',
  },
  {
    name: 'In The Market',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/d6e6rf94_LOGO.jpeg',
    imgClass: 'max-h-12 rounded-lg',
  },
  {
    name: 'Romperjack',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/14jz5tpm_LOGO..webp',
    imgClass: 'max-h-[84px]',
  },
  {
    name: 'Evo Pure',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/k66qa5xm_LOGO...webp',
    imgClass: 'max-h-[60px]',
  },
  {
    name: 'Guard Dog Security',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/0xpg7xli_logo-4.jpg',
    imgClass: 'max-h-[82px]',
  },
  {
    name: 'Prestige Titles',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/tarf6tku_Prestige_Titles_Logo_14_1454x.webp',
    imgClass: 'max-h-[52px]',
  },
  {
    name: 'Narrative & Co',
    src: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/0jzpl78h_LOGO....png',
    imgClass: 'max-h-[72px]',
  },
];

export const STATS = [
  { value: '$55M+', label: 'Revenue Generated', sub: 'For our partners in 2025' },
  { value: '36%+', label: 'Avg. Revenue Lift', sub: 'Added to bottom-line revenue' },
  { value: '10+', label: 'Years Experience', sub: 'Scaling Shopify retention' },
];

export const SERVICES = [
  { title: 'Email + SMS strategy', desc: 'A full retention roadmap mapped to your customer journey.' },
  { title: 'Conversion copywriting', desc: 'On-brand messaging engineered to sell, not just to be read.' },
  { title: 'In-house email design', desc: 'Clean, modern, mobile-first creative from top 1% designers.' },
  { title: 'Flow setup + expansion', desc: 'Welcome, abandon, post-purchase, win-back and beyond.' },
  { title: 'Continuous A/B testing', desc: 'Subject lines, offers, creative, timing and segmentation.' },
  { title: 'Campaign planning', desc: 'Monthly content and promo calendars, ideated end-to-end.' },
  { title: 'Campaign build + send', desc: 'Full execution and QA, so nothing goes live without sign-off.' },
  { title: 'List growth + forms', desc: 'Pop-ups, targeting and conversion-rate improvements.' },
  { title: 'Deliverability management', desc: 'Inbox placement, domain reputation and sending health.' },
  { title: 'List cleaning + segments', desc: 'Suppress unengaged, lift performance, lower costs.' },
  { title: 'Reporting + comms', desc: 'Clear weekly updates, insights and the plan ahead.' },
];

// Real supplied OnBrand proof assets (verified Klaviyo before/after graphics + campaign screenshot)
export const RESULT_ASSETS = {
  spector: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/p9wk7dxu_Screenshot%202026-09-18%20at%2016.44.22.png',
  nuola: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/d6bo7jb3_Screenshot%202026-09-18%20at%2016.43.43.png',
  heights: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/lw0k7uwm_Screenshot%202026-09-18%20at%2016.43.24.png',
  campaign: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/0jtuzsvv_Screenshot%202026-09-18%20at%2016.51.43.png',
};

// Featured case study: facts extracted from the supplied Nuola Wigs case-study PDF (nothing invented)
export const NUOLA_CASE = {
  brand: 'Nuola Wigs',
  tag: 'Premium UK Human Hair Wigs',
  kicker: '9 Years in Business · Zero Email Strategy',
  intro:
    'A UK-based premium human hair wig company serving customers experiencing medical hair loss. Founded and handcrafted by a single maker, the brand had built a loyal following over 9 years entirely through organic social and influencer content, with no paid ads and no email marketing. With an average order value of £800+ and 23,000 email subscribers sitting untouched, the potential was obvious. Unlocking it wasn\u2019t.',
  problem: [
    { stat: '£20k\u2013£60k', label: 'Monthly revenue swinging wildly, impossible to plan or scale' },
    { stat: '23,000', label: 'Email subscribers generating almost nothing' },
    { stat: '20%', label: 'Email attribution vs a 30\u201340% industry standard' },
    { stat: '21% opens', label: 'Deliverability crisis: 9th percentile, 3.22% bounce, 2 emails/mo' },
  ],
  work: [
    'Fixed the broken Klaviyo/Shopify integration that was losing leads',
    'Built a 7\u20138 email welcome flow with founder story, reviews and trust content for high-consideration medical purchases',
    'Rebuilt all core flows: abandoned cart, browse abandonment, post-purchase, win-back',
    'Increased campaign cadence from 2/month to 12/month',
    'Shifted messaging from pure sales to value-based content',
    'Warmed the account methodically with segmented sends to protect deliverability',
    'Redesigned every email for scannability and conversion',
  ],
  insight:
    'With £800 products and medical customers, trust-building had to come before selling. Every email needed to earn the next open.',
  metrics: [
    { label: 'Total Revenue', before: '£64,243', after: '£106,157', change: '+65%' },
    { label: 'Email Revenue', before: '£13,213', after: '£63,947', change: '+384%' },
    { label: 'Email Attribution', before: '20%', after: '60%', change: '+200%' },
    { label: 'Flow Revenue', before: '£5,377', after: '£35,810', change: '+566%' },
    { label: 'Campaign Revenue', before: '£7,836', after: '£28,136', change: '+259%' },
  ],
  deliverability: [
    { value: '51%', label: 'Open Rate', note: 'From 21% (9th pct) to 51% (77th pct)' },
    { value: '0.42%', label: 'Bounce Rate', note: 'From 3.22% (5th pct) to 0.42% (68th pct)' },
    { value: '0.014%', label: 'Spam Complaints', note: 'From 0.098% (5th pct) to 0.014% (35th pct)' },
  ],
  quote: 'Should have been doing this years ago!',
  quoteBy: 'Founder, Nuola Wigs',
};

export const NUOLA_SLACK =
  'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/yckudmz2_1378c9ab7deef82753cbfd872b725d94097a4653590bb8f8a351575cbaaf21b5.webp';

// Additional verified results shown as large readable before/after graphics
export const VERIFIED_RESULTS = [
  {
    id: 'heights',
    brand: 'Heights District',
    tag: 'Luxury Streetwear · Made in the USA',
    highlight: '+62% Revenue',
    img: RESULT_ASSETS.heights,
    context:
      'From $285k at just 12% email attribution to $463k at 66%. A full 10-flow ecosystem plus campaign calendar doubled revenue in 3 months.',
  },
  {
    id: 'spector',
    brand: 'Spector Sports',
    tag: 'Custom Sports Art by Jordan Spector',
    highlight: '+113% Revenue',
    img: RESULT_ASSETS.spector,
    context:
      'From $106k and 7% attribution to $227k and 56% attribution. The 10-flow ecosystem and campaign calendar more than doubled revenue in 5 months.',
  },
];

export const CAMPAIGN_PROOF = {
  img: RESULT_ASSETS.campaign,
  headline: '$77,000 from just two campaigns',
  detail:
    'Two sends in a single morning drove $26,829 and $50,053 in attributed revenue, at 31% and 40% open rates.',
};

// Custom Trustpilot review showcase (NOT an official live Trustpilot TrustBox widget).
// Overall figures below are transcribed from the genuine Trustpilot profile screenshot.
// `reviews` uses the real individual review screenshots inside consistent card containers.
// 8 genuine reviews exist in total; 4 screenshots supplied so far. Append the remaining
// 4 review objects to `reviews` when supplied (carousel + pagination adapt automatically).
export const TRUSTPILOT = {
  profileUrl: 'https://ie.trustpilot.com/review/onbrandemails.com',
  logo: 'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/q64eygo6_Trustpilot-Logo.webp',
  score: '4.3',
  scoreValue: 4.3,
  label: 'Excellent',
  totalReviews: 8,
  reviews: [
    {
      id: 'jake',
      name: 'Jake',
      title: 'Great agency with a great team',
      rating: 5,
      image:
        'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/2v98rcde_Screenshot%202026-09-23%20at%2010.52.20.png',
      alt: 'Trustpilot 5-star review by Jake titled “Great agency with a great team”, dated 22 September 2026, an unprompted review saying the OnBrand team close to doubled their email/SMS revenue in 4 months.',
    },
    {
      id: 'amy',
      name: 'Amy',
      title: 'A great team to work with',
      rating: 5,
      image:
        'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/23doppmz_Screenshot%202026-09-23%20at%2010.52.44.png',
      alt: 'Trustpilot 5-star review by Amy titled “A great team to work with”, dated 18 September 2026, an unprompted review praising OnBrand for elevating their email flows and campaigns and account manager Charne.',
    },
    {
      id: 'dan',
      name: 'Dan',
      title: 'Exactly what an agency should be',
      rating: 5,
      image:
        'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/m2b1yi51_Screenshot%202026-09-23%20at%2010.53.01.png',
      alt: 'Trustpilot 5-star review by Dan titled “Exactly what an agency should be”, dated 18 September 2026, an unprompted review praising OnBrand’s client comms and on-brand email designs after 5 months.',
    },
    {
      id: 'yasmine',
      name: 'Yasmine Dabgotra',
      title: 'Luke and Jake are two wonderful...',
      rating: 5,
      image:
        'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/kfokz6zd_Screenshot%202026-09-23%20at%2010.53.19.png',
      alt: 'Trustpilot 5-star review by Yasmine Dabgotra titled “Luke and Jake are two wonderful...”, dated 17 September 2026, an unprompted review praising OnBrand for repairing deliverability and building evergreen flows.',
    },
    {
      id: 'kieran',
      name: 'Kieran',
      title: "Best agency we've ever worked with",
      rating: 5,
      image:
        'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/eycn2ng9_Screenshot%202026-09-23%20at%2011.04.45.png',
      alt: 'Trustpilot 5-star review by Kieran titled “Best agency we\'ve ever worked with”, dated 18 September 2026, an unprompted review saying OnBrand tripled their Q4 revenue year over year.',
    },
    {
      id: 'mark',
      name: 'Mark',
      title: 'A fantastic team to work with',
      rating: 5,
      image:
        'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/n7g3naiq_Screenshot%202026-09-23%20at%2011.05.03.png',
      alt: 'Trustpilot 5-star review by Mark titled “A fantastic team to work with”, dated 14 April 2026, an unprompted review praising great communication and Klaviyo flows that generate results.',
    },
    {
      id: 'liam',
      name: 'Liam',
      title: 'Exceptional Service and Results!',
      rating: 5,
      image:
        'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/0b1ch335_Screenshot%202026-09-23%20at%2011.05.21.png',
      alt: 'Trustpilot 5-star review by Liam titled “Exceptional Service and Results!”, dated 1 May 2026, an unprompted review praising over a year of work improving engagement rates and ROI.',
    },
    {
      id: 'rich',
      name: 'Rich Mendoza',
      title: 'Streetwear Clothing Brand',
      rating: 5,
      image:
        'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/fwbl8mnt_Screenshot%202026-09-23%20at%2011.05.38.png',
      alt: 'Trustpilot 5-star review by Rich Mendoza titled “Streetwear Clothing Brand”, dated 22 April 2026, an unprompted review praising real growth from dialled-in email marketing, referencing @heightsdistrict.',
    },
  ],
};

// Real client video testimonials (hosted on YouTube). Structured to hold at least two.
// simply set `videoId` on the next entry when testimonial video #2 is supplied.
export const VIDEO_TESTIMONIALS = [
  {
    videoId: 'l6_YATHrRh4',
    label: 'Client Interview',
    caption: 'A premium, parent-founded children\u2019s bath & personal care brand shares their experience.',
  },
  {
    videoId: 'RLAS4mZd-1k',
    label: 'Client Interview',
    caption: 'Autumn Blu shares their 7-figure email marketing journey with OnBrand.',
  },
];


export const PROCESS = [
  { step: '01', title: 'Qualification', desc: 'We make sure you have a solid brand ready to grow within the next 90 days.' },
  { step: '02', title: 'The Free Audit', desc: 'We open your Klaviyo account and show you exactly where you are losing money.' },
  { step: '03', title: 'The Rebuild', desc: 'We deconstruct and rebuild your flows, forms, design and deliverability.' },
  { step: '04', title: 'Scale + Optimise', desc: 'We test, iterate and compound results month over month, profitably.' },
];

export const COMPARISON = {
  inhouse: {
    title: 'The In-House Team',
    subtitle: 'Average annual cost for a qualified US-based team.',
    rows: [
      { label: 'Senior Email Strategist', value: '$70k+' },
      { label: 'Direct Response Copywriter', value: '$40k+' },
      { label: 'Senior UX/UI Designer', value: '$40k+' },
      { label: 'Klaviyo Technical Manager', value: '$35k+' },
      { label: 'Taxes, Benefits & Overhead (+30%)', value: '+$55k+' },
    ],
    total: '~$240,000/yr',
    footnotes: ['Sick Days', 'Recruitment Fees', 'Management Time'],
  },
  onbrand: {
    title: 'The OnBrand Partner',
    subtitle: 'One flat monthly fee. No overhead. No headaches.',
    rows: [
      { label: 'Full Strategy Team', value: 'Included' },
      { label: 'World-Class Copywriting', value: 'Included' },
      { label: 'Premium Design Studio', value: 'Included' },
      { label: 'Klaviyo Implementation', value: 'Included' },
      { label: 'Taxes, Benefits & Overhead', value: '$0' },
    ],
    total: '~15% of the cost',
    footnotes: ['No churn', 'No hiring', 'Start this week'],
  },
};

export const FAQS = [
  { q: 'What makes OnBrand different?', a: 'Most agencies sound great before you sign, then struggle to execute. OnBrand has a proven track record scaling 8- to 9-figure Shopify brands, built for long-term partnerships rather than churn-and-burn.' },
  { q: 'What services do you offer?', a: 'Full-scope Klaviyo email + SMS: one-time flow builds, campaign packages and full-service account management. We handle everything from A to Z: strategy, copy, design, builds, testing and optimisation.' },
  { q: 'How long does it take to see results?', a: 'The first 30 days are setup and foundation: flows, forms, deliverability and quick wins. The biggest improvements usually show up in 60 to 90 days as testing and iteration compound.' },
  { q: 'What do you need from us to get started?', a: 'Access to Klaviyo and your ecommerce platform, plus a short onboarding call so we can learn your products, margins, segments and brand voice. Minimal lift on your side.' },
  { q: 'Will you match our brand voice and design?', a: 'Yes. Everything is created to feel native to your brand, never templated agency work. We send previews for approval so nothing goes live without your sign-off.' },
];

export const FOUNDERS_TOGETHER =
  'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/iyicftaf_DSC02884%20%281%29.webp';

export const FOUNDERS = [
  {
    name: 'Luke',
    role: 'Co-Founder',
    photo:
      'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/vojcxbax_DSC02738%20%281%29.webp',
    socials: {
      linkedin: 'https://www.linkedin.com/in/luke-kelly-wilmot-33075a172/',
      instagram: 'https://www.instagram.com/onbrand.emails/?hl=en',
      youtube: 'https://youtube.com/@jakeonbrand?si=41VRNkly-7FhxMIa',
    },
  },
  {
    name: 'Jake',
    role: 'Co-Founder',
    photo:
      'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/abh53tsv_DSC02704%20%281%29.webp',
    socials: {
      linkedin: 'https://www.linkedin.com/in/jake-kelly-bb81a3323/',
      instagram: 'https://www.instagram.com/jakefromobe/?hl=en',
      youtube: 'https://youtube.com/@jakeonbrand?si=41VRNkly-7FhxMIa',
    },
  },
];

export const EMAILS_SHOWCASE =
  'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/7dplssps_EMAILS.webp';

export const KLAVIYO_BADGE =
  'https://customer-assets-39nsmqrw.emergentagent.net/job_email-marketing-hub-18/artifacts/yq9i703t_klaviyo-partner-badge-light.webp';
